import { render, staticRenderFns } from "./EmailSend.vue?vue&type=template&id=6ea11dad&scoped=true&"
import script from "./EmailSend.vue?vue&type=script&lang=js&"
export * from "./EmailSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea11dad",
  null
  
)

export default component.exports